"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VENUE_AGGREGATE_WINDOW_DESCRIPTIONS = exports.VENUE_AGGREGATE_WINDOW_LABELS = exports.MAX_VENUE_AGGREGATE_WINDOW_DAYS = exports.MIN_VENUE_AGGREGATE_WINDOW_DAYS = exports.DEFAULT_RECENT_VIEWS_WINDOW_DAYS = exports.DEFAULT_RECENT_CHECKINS_WINDOW_DAYS = void 0;
exports.buildDefaultVenueAggregateWindowsConfig = buildDefaultVenueAggregateWindowsConfig;
exports.parseVenueAggregateWindows = parseVenueAggregateWindows;
exports.validateVenueAggregateWindowsForSave = validateVenueAggregateWindowsForSave;
exports.DEFAULT_RECENT_CHECKINS_WINDOW_DAYS = 14;
exports.DEFAULT_RECENT_VIEWS_WINDOW_DAYS = 7;
exports.MIN_VENUE_AGGREGATE_WINDOW_DAYS = 1;
exports.MAX_VENUE_AGGREGATE_WINDOW_DAYS = 90;
exports.VENUE_AGGREGATE_WINDOW_LABELS = {
  recentCheckinsWindowDays: 'Recent check-ins',
  recentViewsWindowDays: 'Recent views (peeks)'
};
exports.VENUE_AGGREGATE_WINDOW_DESCRIPTIONS = {
  recentCheckinsWindowDays: 'Visit check-ins within this many days count toward recentCheckins on the map and venue activity stats.',
  recentViewsWindowDays: 'Unique users who peeked at a venue within this many days count toward views on the map and RecentViews aggregates.'
};
function buildDefaultVenueAggregateWindowsConfig() {
  return {
    recentCheckinsWindowDays: exports.DEFAULT_RECENT_CHECKINS_WINDOW_DAYS,
    recentViewsWindowDays: exports.DEFAULT_RECENT_VIEWS_WINDOW_DAYS
  };
}
function isPlainObject(value) {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
function parseWindowDays(value, fallback) {
  if (typeof value === 'number' && Number.isInteger(value)) {
    if (value >= exports.MIN_VENUE_AGGREGATE_WINDOW_DAYS && value <= exports.MAX_VENUE_AGGREGATE_WINDOW_DAYS) {
      return value;
    }
  }
  return fallback;
}
function parseVenueAggregateWindows(raw) {
  const defaults = buildDefaultVenueAggregateWindowsConfig();
  if (!isPlainObject(raw)) {
    return defaults;
  }
  return {
    recentCheckinsWindowDays: parseWindowDays(raw.recentCheckinsWindowDays, defaults.recentCheckinsWindowDays),
    recentViewsWindowDays: parseWindowDays(raw.recentViewsWindowDays, defaults.recentViewsWindowDays)
  };
}
function windowDaysError(field, value) {
  if (typeof value !== 'number' || !Number.isInteger(value)) {
    return {
      message: "venueAggregateWindows.".concat(field, " must be an integer.")
    };
  }
  if (value < exports.MIN_VENUE_AGGREGATE_WINDOW_DAYS || value > exports.MAX_VENUE_AGGREGATE_WINDOW_DAYS) {
    return {
      message: "venueAggregateWindows.".concat(field, " must be between ").concat(exports.MIN_VENUE_AGGREGATE_WINDOW_DAYS, " and ").concat(exports.MAX_VENUE_AGGREGATE_WINDOW_DAYS, ".")
    };
  }
  return null;
}
function validateVenueAggregateWindowsForSave(value) {
  if (!isPlainObject(value)) {
    return {
      message: 'venueAggregateWindows must be an object.'
    };
  }
  const recentCheckinsError = windowDaysError('recentCheckinsWindowDays', value.recentCheckinsWindowDays);
  if (recentCheckinsError) {
    return recentCheckinsError;
  }
  const recentViewsError = windowDaysError('recentViewsWindowDays', value.recentViewsWindowDays);
  if (recentViewsError) {
    return recentViewsError;
  }
  return null;
}
//# sourceMappingURL=venue-aggregate-windows-config.js.map